import React from "react";
import { useSearchParams } from "react-router-dom";
import Button from "../../Core/Components/CustomButton";

const SetNewPasswordSuccessScreen = () => {
  const [searchParams] = useSearchParams();
  const showLoginButton = searchParams.get("loginButton") === "1";

  return (
    <div className="w-full h-[93vh] bg-[#EDF8F2] flex flex-col">
      <div className="flex flex-col items-center justify-center flex-grow py-10">
        <div className="w-[179px] h-[179px] rounded-full bg-[#4DCA86] bg-opacity-20 flex items-center justify-center">
          <div className="w-[134px] h-[134px] rounded-full bg-[#4DCA86] flex items-center justify-center">
            <img
              src="/images/tick.svg"
              alt="Success Check"
              className="w-12 h-12"
            />
          </div>
        </div>

        <p className="mt-6 text-[#4DCA86] font-poppins font-semibold text-xl">
          SUCCESS!
        </p>
      </div>

      <div className="bg-white px-6 py-8 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] h-[190px]">
        <p className="text-center text-sm text-black mt-6 mb-6 leading-none font-normal font-poppins">
          Your password has been reset successfully!
        </p>
        {showLoginButton && (
          <Button
            width="full"
            onClick={() => {
              const deeplink = "myapp://login";
              window.location.href = deeplink;
            }}
          >
            <div className="flex items-center justify-center gap-2 w-full">
              <p className="font-poppins font-medium text-sm leading-none">
                Login
              </p>
              <img
                src="\assets\icons\details\arrow-full.svg"
                className="w-5 h-5 rotate-180"
                alt="arrow"
              />
            </div>
          </Button>
        )}
      </div>
    </div>
  );
};

export default SetNewPasswordSuccessScreen;
